/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayingCreator
 */
export interface PlayingCreator {
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    profileImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof PlayingCreator
     */
    viewerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    streamTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    gameName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayingCreator
     */
    platform?: string;
}

/**
 * Check if a given object implements the PlayingCreator interface.
 */
export function instanceOfPlayingCreator(value: object): value is PlayingCreator {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function PlayingCreatorFromJSON(json: any): PlayingCreator {
    return PlayingCreatorFromJSONTyped(json, false);
}

export function PlayingCreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayingCreator {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'displayName': json['displayName'],
        'profileImageUrl': json['profileImageUrl'] == null ? undefined : json['profileImageUrl'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'viewerCount': json['viewerCount'] == null ? undefined : json['viewerCount'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
        'gameName': json['gameName'] == null ? undefined : json['gameName'],
        'platform': json['platform'] == null ? undefined : json['platform'],
    };
}

export function PlayingCreatorToJSON(json: any): PlayingCreator {
    return PlayingCreatorToJSONTyped(json, false);
}

export function PlayingCreatorToJSONTyped(value?: PlayingCreator | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'displayName': value['displayName'],
        'profileImageUrl': value['profileImageUrl'],
        'thumbnailUrl': value['thumbnailUrl'],
        'viewerCount': value['viewerCount'],
        'streamTitle': value['streamTitle'],
        'gameName': value['gameName'],
        'platform': value['platform'],
    };
}

